
import * as React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface DeleteDocumentDialogProps {
  open: boolean;
  documentName?: string;
  loading: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const DeleteDocumentDialog: React.FC<DeleteDocumentDialogProps> = ({
  open,
  loading,
  documentName,
  onConfirm,
  onCancel,
}) => (
  <Dialog open={open} onOpenChange={onCancel}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>Delete Document</DialogTitle>
      </DialogHeader>
      <div className="py-2">
        Are you sure you want to delete <span className="font-bold">{documentName}</span>? This action cannot be undone.
      </div>
      <DialogFooter>
        <Button onClick={onCancel} variant="outline" disabled={loading}>
          Cancel
        </Button>
        <Button onClick={onConfirm} disabled={loading} variant="destructive" aria-disabled={loading}>
          {loading ? "Deleting…" : "Delete"}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
